<ng-container [formGroup]="fg" [style.color]="inputColor">
  <label
    class="displayInLine"
    appConfigSettingsParagraph
    [style.color]="fontColor ? fontColor : null"
    [style.font-family]="fontFamily ? fontFamily : null"
    [style.font-size.px]="fontSize ? fontSize : null"
  >
    <p>
      {{ placeholder | translate }}
    </p>
    <div
      *ngIf="additionalInfoInsurer!=null"
    >
      <mat-icon class="infoIcon" (click)="openPopup()" type="button">info</mat-icon>
    </div>
  </label>
  <input
    type="text"
    placeholder="{{ showPlaceholder == true ? (placeholder | translate) : ''}}"
    aria-label="Number"
    [formControl]="myControl"
    [matAutocomplete]="auto"
    appConfigSettingsBorder
    appConfigSettingsInput
    [style.borderColor]="inputBorderColor ? inputBorderColor : null"
    [style.color]="inputColor ? inputColor : null"
  />

  <mat-autocomplete #auto="matAutocomplete">
    <mat-option
      *ngFor="let option of filteredOptions" [value]="option.text"
      appConfigSettingsInput
      [style.color]="inputColor ? inputColor : null"
    >
      {{option.text}}
    </mat-option>
  </mat-autocomplete>

  <mat-error class="error-message" *ngIf="isAnyError">
    <ng-container *ngIf="messageError">
      {{ control.errors.message }}
    </ng-container>
    <ng-container *ngIf="requiredError">
      {{ isRequiredMessage }}
    </ng-container>
  </mat-error>
</ng-container>
